import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './styles/dashboardMobile.css';
import Dashboard from './pages/Dashboard';
import StockDashboard from './pages/StockDashboard';
import AnalyPage from './pages/AnalyPage';
import AnalyCryptoPage from './pages/AnalyCryptoPage';
import AnalyCryptoBinancePage from './pages/AnalyCryptoBinancePage';
import CoinDashboard from './pages/CoinDashboard';
import CryptoPage from './pages/CryptoPage';
import LandingPage from './pages/LandingPage';
import SystemArchitecturePage from './pages/SystemArchitecturePage';
import KiwoomPage from './pages/KiwoomPage';
import BinanceAlertChartsPage from './pages/BinanceAlertChartsPage';
import { RealtimeRankingFluctuationProvider } from './context/RealtimeRankingFluctuationContext';

// 방문자 추적 컴포넌트
const VisitorTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const visitorData = {
          path: location.pathname,
          screen_size: `${window.screen.width}x${window.screen.height}`,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        await fetch('/mercury-backend/track-visitor', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(visitorData),
        });
      } catch (error) {
        // 에러는 무시 (추적 실패해도 페이지는 정상 작동)
        console.debug('Visitor tracking failed:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <RealtimeRankingFluctuationProvider>
        <VisitorTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard-old" element={
    <div className="App">
      <header className="app-header">
        <h1 className="app-title">mercury</h1>
        <nav style={{ marginTop: '10px' }}>

        </nav>
      </header>

      <main className="app-main">
        <Dashboard />
      </main>
    </div>
          } />
          <Route path="/stock" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - 주식</h1>
                <nav style={{ marginTop: '10px' }}>
                  
                </nav>
              </header>
              
              <main className="app-main">
                <StockDashboard />
              </main>
            </div>
          } />
          <Route path="/analy" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - 종목별상세 분석</h1>
                <nav style={{ marginTop: '10px' }}>
                  
                </nav>
              </header>
              
              <main className="app-main">
                <AnalyPage />
              </main>
            </div>
          } />
          <Route path="/analy-crypto" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - 코인 백테스트 분석</h1>
                <nav style={{ marginTop: '10px' }}>

                </nav>
              </header>

              <main className="app-main">
                <AnalyCryptoPage />
              </main>
            </div>
          } />
          <Route path="/analy-crypto-binance" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - Binance Futures 백테스트 분석</h1>
                <nav style={{ marginTop: '10px' }}>

                </nav>
              </header>

              <main className="app-main">
                <AnalyCryptoBinancePage />
              </main>
            </div>
          } />
          <Route path="/crypto" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - 크립토</h1>
                <nav style={{ marginTop: '10px' }}>

                </nav>
              </header>

              <main className="app-main">
                <CryptoPage />
              </main>
            </div>
          } />
          <Route path="/sa" element={<SystemArchitecturePage />} />
          {/* /dashboard → EN (landing CTA). /kr · /en · /fr keep full locale dashboards. */}
          <Route path="/dashboard" element={<KiwoomPage locale="en" />} />
          <Route path="/dashboard/en" element={<KiwoomPage locale="en" />} />
          <Route path="/dashboard/kr" element={<KiwoomPage locale="kr" />} />
          <Route path="/dashboard/fr" element={<KiwoomPage locale="fr" />} />
          <Route path="/en" element={<KiwoomPage locale="en" />} />
          <Route path="/kr" element={<KiwoomPage locale="kr" />} />
          <Route path="/fr" element={<KiwoomPage locale="fr" />} />
          {/* Binance 패널 헤더의 '차트' 버튼 — 오늘 업비트 알림 심볼의 24h 1분봉 */}
          <Route path="/binance-charts" element={<BinanceAlertChartsPage locale="en" />} />
          <Route path="/binance-charts/en" element={<BinanceAlertChartsPage locale="en" />} />
          <Route path="/binance-charts/kr" element={<BinanceAlertChartsPage locale="kr" />} />
          <Route path="/binance-charts/fr" element={<BinanceAlertChartsPage locale="fr" />} />
          <Route path="/coin" element={
            <div className="App">
              <header className="app-header">
                <h1 className="app-title">mercury - 코인</h1>
                <nav style={{ marginTop: '10px' }}>
                  
                </nav>
              </header>
              
              <main className="app-main">
                <CoinDashboard />
              </main>
            </div>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RealtimeRankingFluctuationProvider>
    </BrowserRouter>
  );
}

export default App;